<template>
    <Accordion :value="activeIndex" expandIcon="pi pi-plus" collapseIcon="pi pi-minus"
        class="w-full h-full border-round-2xl overflow-hidden">
        <AccordionPanel v-for="(tab, index) of list" :key="tab[lang].title" :value="index.toString()" 
            :class="(index==list.length-1) ? 'border-0 border-none' : ''" >
            <AccordionHeader>
                <span class="xl:py-2 xl:px-3 lg:px-2 xl:text-lg outline-none font-medium text-sm" :id="'index'+index">{{ tab[lang].title }}</span>
            </AccordionHeader>
            <AccordionContent class="p-0 m-0">
                <p class="w-full 
                    px-0 xl:px-3 lg:px-2 
                    text-sm xl:text-base lg:text-base md:text-base">{{tab[lang].content}}
                </p>
            </AccordionContent>
        </AccordionPanel>
    </Accordion>
</template>

<script>
export default {
    props: ['tabs', 'count'],
    data() {
        return {
            list: [],
            activeIndex: null
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    watch: {
        tabs: {
            handler: function(){
                if(this.tabs){
                    if(this.count && this.count>0){
                        if(this.tabs.length>this.count) this.list = this.tabs.slice(0, this.count)
                        else this.list = this.tabs
                    } 
                    else this.list = this.tabs
                }
            },
            deep: true
        }
    },  
    methods:{
        getActiveIndex(){
            const url = new URL(window.location.href)
            this.activeIndex = (url.searchParams.get('tab')) ? url.searchParams.get('tab') : null
        }
    },
    mounted() {
        if(this.tabs){
            if(this.count && this.count>0){
                if(this.tabs.length>this.count) this.list = this.tabs.slice(0, this.count)
                else this.list = this.tabs
            } 
            else this.list = this.tabs
            this.getActiveIndex()
        }
    }
}
</script>